//Notice: the listed keys are being pulled from contentful model: Section - configurable

export default {
  TEXT_LEFT_IMAGE_RIGHT: 'text left, image right',
  TEXT_RIGHT_IMAGE_LEFT: 'text right, image left',
  TEXT_TOP_IMAGE_BOTTOM: 'text top, image bottom',
  TEXT_BOTTOM_IMAGE_TOP: 'text bottom, image top',
};
